/**
 * Central Pricing — Single frontend source for all prices.
 * All components MUST import prices from here.
 * Matches backend config/pricing.py exactly.
 */

export const PRO_PRICES = {
  monthly: { usd: 19.99, nok: 199, savingsPercent: 0 },
  yearly: { usd: 149, nok: 1490, savingsPercent: 38, monthlyEquivalentUsd: 12.42, monthlyEquivalentNok: 124.17 },
};

export function detectCurrency() {
  try {
    const lang = navigator.language || navigator.languages?.[0] || '';
    if (/^(nb|nn|no)/i.test(lang)) return 'nok';
  } catch {}
  return 'usd';
}

export function formatPrice(amount, currency = 'usd') {
  if (currency === 'nok') return `${amount} kr`;
  return `$${amount}`;
}

export function getProPrice(interval = 'monthly', currency = 'usd') {
  const plan = PRO_PRICES[interval];
  return plan ? plan[currency] : PRO_PRICES.monthly[currency];
}

export function getProLabel(currency = 'usd') {
  const monthly = PRO_PRICES.monthly[currency];
  const yearly = PRO_PRICES.yearly[currency];
  const suffix = currency === 'nok' ? ' kr' : '';
  const prefix = currency === 'nok' ? '' : '$';
  return {
    monthly: `${prefix}${monthly}${suffix}/month`,
    yearly: `${prefix}${yearly}${suffix}/year`,
    savingsPercent: PRO_PRICES.yearly.savingsPercent,
  };
}

/** Map Stripe plan keys for checkout */
export function getStripePlanKey(interval = 'monthly') {
  return interval === 'yearly' ? 'pro_yearly' : 'pro';
}
